import React from 'react';


interface IPaymentMethodProps {
  active: boolean;
  imgUrl: string;
  name: string;
  description: string;
  select: (name: string) => void;
}

export default function PaymentMethod(props: IPaymentMethodProps) {
  const {description, imgUrl, name, select } = props;
  const setMethod = () => select(name);

  return (
    <div className="col-12 col-sm-4 col-lg-4">
      <article
        className="payment-box-without-shadow"
        onClick={setMethod}
        role="presentation"
      >
        <figure>
          <h5>{description}</h5>
          <img
            className="d-flex mx-auto img-fluid payment-box-card-img"
            src={imgUrl}
            alt="Método de Pago"
          />
        </figure>
      </article>
      <div className="w-100 d-sm-none mb20" />
    </div>
  );
}
